/* RESPONSIBLE TEAM: team-standalone */
import { RenderableType } from 'embercom/models/data/inbox/renderable-types';
import { type RenderableData } from 'embercom/objects/inbox/renderable-data';
import { EntityType } from 'embercom/models/data/entity-types';

export interface HandOffData {
  routing_attributes?: Record<string, string>;
}

export interface StandalonePlatformHandoffWireFormat {
  renderable_type: RenderableType;
  handoff_stage?: 'initiated' | 'completed';
  handoff_type: string;
  handoff_success?: boolean;
  handoff_data?: HandOffData;
}

type HandoffStage = StandalonePlatformHandoffWireFormat['handoff_stage'];

export default class StandalonePlatformHandoff implements RenderableData {
  readonly renderableType: RenderableType = RenderableType.StandalonePlatformHandoff;
  readonly handoffType: string;
  readonly handoffStage: HandoffStage;
  readonly handoffSuccess?: boolean;
  readonly handoffData?: HandOffData;

  constructor(
    handoff_type: string,
    handoff_success: boolean | undefined,
    handoff_stage: HandoffStage,
    handoff_data: HandOffData | undefined,
  ) {
    this.handoffType = handoff_type;
    this.handoffStage = handoff_stage;
    this.handoffSuccess = handoff_success;
    this.handoffData = handoff_data;
  }

  get adminOnly() {
    return true;
  }

  get creatingEntity() {
    return { type: EntityType.Bot, id: -1 };
  }

  static deserialize(json: StandalonePlatformHandoffWireFormat): StandalonePlatformHandoff {
    return new StandalonePlatformHandoff(
      json.handoff_type,
      json.handoff_success,
      json.handoff_stage,
      json.handoff_data,
    );
  }
}
